import { api } from './utils';

export const authAPI = {
  // POST /api/auth/login
  login: (credentials) => api.post('/api/auth/login', credentials),
  
  // POST /api/auth/refresh
  refresh: () => api.post('/api/auth/refresh'),
  
  // POST /api/auth/logout
  logout: () => api.post('/api/auth/logout'),
  
  // GET /api/auth/profile
  getProfile: () => api.get('/api/auth/profile'),
  
  // POST /api/auth/activate
  activate: (activationData) => api.post('/api/auth/activate', activationData),
  
  // POST /api/auth/forgot-password
  forgotPassword: (email) => api.post('/api/auth/forgot-password', { email }),
  
  // POST /api/auth/reset-password
  resetPassword: (resetData) => api.post('/api/auth/reset-password', resetData),
  
  // GET /api/auth/verify-reset-token
  verifyResetToken: (token) => api.get('/api/auth/verify-reset-token', { token }),
  
  // PUT /api/auth/change-password
  changePassword: (passwordData) => api.put('/api/auth/change-password', passwordData),
}; 